<footer class="d-flex flex-wrap justify-content-between align-items-center p-3 mt-3" style="background-color: rgba(0, 0, 0, 0.04)">
    <p class="col-md-6 mb-0 text-muted p-0 my-0">© {{ currentYear }} FirePi</p>
    <!-- TODO: Add the respective page links -->
    <ul class="nav col-md-6 justify-content-end">
        <!-- <li class="nav-item"><a href="/firepi-contacts" target="_blank" class="nav-link my-0 mx-2 p-0 text-muted">Contatti</a></li> -->
        <li class="nav-item"><a href="/privacy" target="_blank" class="nav-link my-0 mx-2 p-0 text-muted">Privacy</a></li>
        <li class="nav-item">
            <a href="https://firepisupport.protezionecivile.tn.it" target="_blank" class="nav-link my-0 mx-2 p-0 text-muted"
                >Segnala un problema</a
            >
        </li>
    </ul>
</footer>
